if (!customElements.get('custom-dropdown')) {
  customElements.define(
    'custom-dropdown',
    class CustomDropdown extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        this.dropdowns = this.querySelectorAll('.custom-dropdown');

        this.dropdowns.forEach((dropdown) => {
          const selected = dropdown.querySelector('.custom-dropdown__selected');
          const options = dropdown.querySelector('.custom-dropdown__options');
          const optionElements = dropdown.querySelectorAll('.custom-dropdown__option');
          const tagsContainer = dropdown.querySelector('.custom-dropdown__tags');
          const placeholder = dropdown.querySelector('.custom-dropdown__placeholder');
          const hiddenInput = dropdown.querySelector('input[type="hidden"]');
          const fieldId = dropdown.dataset.fieldId;
          const fieldName = dropdown.dataset.fieldName;

          // Store selected values
          dropdown.selectedValues = [];

          // Toggle dropdown on click
          selected.addEventListener('click', () => {
            this.toggleDropdown(dropdown);
          });

          // Close dropdown when clicking outside
          document.addEventListener('click', (event) => {
            if (!dropdown.contains(event.target)) {
              this.closeDropdown(dropdown);
            }
          });

          // Handle option selection
          optionElements.forEach((option) => {
            option.addEventListener('click', () => {
              const value = option.dataset.value;
              const text = option.textContent.trim();

              // Toggle selection
              if (this.isSelected(dropdown, value)) {
                this.removeValue(dropdown, value);
                option.classList.remove('selected');
              } else {
                this.addValue(dropdown, value, text);
                option.classList.add('selected');
              }

              // Update hidden input value
              hiddenInput.value = dropdown.selectedValues.map((item) => item.value).join(',');

              // Update UI
              this.updateTagsDisplay(dropdown);

              // Toggle placeholder visibility
              placeholder.style.display = dropdown.selectedValues.length > 0 ? 'none' : 'block';

              // Keep dropdown open for multi-select functionality
              // Uncomment the line below if you want to close the dropdown after each selection
              // this.closeDropdown(dropdown);
            });
          });

          // Handle keyboard navigation
          selected.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              this.toggleDropdown(dropdown);
            }
          });
        });
      }

      toggleDropdown(dropdown) {
        const options = dropdown.querySelector('.custom-dropdown__options');
        const isHidden = options.hasAttribute('hidden');

        if (isHidden) {
          this.openDropdown(dropdown);
        } else {
          this.closeDropdown(dropdown);
        }
      }

      openDropdown(dropdown) {
        // Close all other dropdowns first
        this.dropdowns.forEach((d) => {
          if (d !== dropdown) this.closeDropdown(d);
        });

        const options = dropdown.querySelector('.custom-dropdown__options');
        options.removeAttribute('hidden');
        dropdown.classList.add('active');
      }

      closeDropdown(dropdown) {
        const options = dropdown.querySelector('.custom-dropdown__options');
        options.setAttribute('hidden', '');
        dropdown.classList.remove('active');
      }

      isSelected(dropdown, value) {
        return dropdown.selectedValues.some((item) => item.value === value);
      }

      addValue(dropdown, value, text) {
        dropdown.selectedValues.push({ value, text });
      }

      removeValue(dropdown, value) {
        dropdown.selectedValues = dropdown.selectedValues.filter((item) => item.value !== value);
      }

      updateTagsDisplay(dropdown) {
        const tagsContainer = dropdown.querySelector('.custom-dropdown__tags');
        tagsContainer.innerHTML = '';

        dropdown.selectedValues.forEach((item) => {
          const tag = document.createElement('div');
          tag.className = 'custom-dropdown__tag';
          tag.innerHTML = `
            <span>${item.text}</span>
            <span class="custom-dropdown__tag-remove">
              <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close-small" fill="none" viewBox="0 0 12 12">
                <path d="M8.5 3.5L3.5 8.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M3.5 3.5L8.5 8.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
          `;

          // Add remove functionality
          const removeBtn = tag.querySelector('.custom-dropdown__tag-remove');
          removeBtn.addEventListener('click', (event) => {
            event.stopPropagation();

            // Remove from selected values
            this.removeValue(dropdown, item.value);

            // Update option state
            const option = dropdown.querySelector(`.custom-dropdown__option[data-value="${item.value}"]`);
            if (option) option.classList.remove('selected');

            // Update hidden input
            const hiddenInput = dropdown.querySelector('input[type="hidden"]');
            hiddenInput.value = dropdown.selectedValues.map((item) => item.value).join(',');

            // Update UI
            this.updateTagsDisplay(dropdown);

            // Toggle placeholder
            const placeholder = dropdown.querySelector('.custom-dropdown__placeholder');
            placeholder.style.display = dropdown.selectedValues.length > 0 ? 'none' : 'block';
          });

          tagsContainer.appendChild(tag);
        });
      }
    }
  );
}
